var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation_diagram"},[(!_vm.isReviewPlan)?_c('back-step',{attrs:{"goList":[{
      url: '/cases',
      name: _vm.$t('casesDetail.casesChildren.common.bl')
    }, {
      url: '/cases/detail',
      name: _vm.$t('casesDetail.casesChildren.common.blxq')
    }],"currentTxt":_vm.currentTxtObj[_vm.tabKey]}}):_vm._e(),_c('operation-view-con',{on:{"changeTabKey":_vm.changeTabKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }